export enum Permissions {
  ClientsRead = "Clients Read",
  ClientsChange = "Clients Add/Edit",
  ClientsProfileRead = "Clients Profile Tab Read",
  ClientsProfileChange = "Clients Profile Tab Add/Edit",
  ClientsComplianceRead = "Clients Compliance Tab Read",
  ClientsComplianceChange = "Clients Compliance Tab Add/Edit",
  ClientsNotesRead = "Clients Notes Tab Read",
  ClientsNotesChange = "Clients Notes Tab Add/Edit",
  ClientsBillToRead = "Clients BillTo Tab Read",
  ClientsBillToChange = "Clients BillTo Tab Add/Edit",
  ClientsBoardsRead = "Clients Boards Tab Read",
  ClientsBoardsChange = "Clients Boards Tab Add/Edit",
  ClientsBillToProfileRead = "Clients BillTo Profile Tab Read",
  ClientsBillToProfileChange = "Clients BillTo Profile Tab Add/Edit",
  ClientsBillToContactsRead = "Clients BillTo Contacts Tab Read",
  ClientsBillToContactsChange = "Clients BillTo Contacts Tab Add/Edit",
  ClientsBillToBillingRead = "Clients BillTo Billing Tab Read",
  ClientsBillToBillingChange = "Clients BillTo Billing Tab Add/Edit",
  BoardsRead = "Boards Read",
  BoardsChange = "Boards Add/Edit",
  LessorRead = "Lessor Read",
  LessorChange = "Lessor Add/Edit",
  ProductsRead = "Products Read",
  ProductsChange = "Products Add/Edit",
  ClientProductsRead = "Client Products Read",
  ClientProductsChange = "Client Products Add/Edit",
  EquipmentCodesRead = "Equipment Codes Read",
  EquipmentCodesChange = "Equipment Codes Add/Edit",
  RatesRead = "Rates Read",
  RatesChange = "Rates Add/Edit",
  PeopleNetChange = "PeopleNet Testing Tool Add/Edit",
  AccessorialsRead = "Accessorials Read",
  AccessorialsChange = "Accessorials Add/Edit",
  LocationsRead = "Locations Read",
  LocationsChange = "Locations Add/Edit",
  TChekImportChange = "T-Chek Import Add/Edit",
  TChekExpensesChange = "T-Chek Fuel Expenses Add/Edit",
  TChekExpressCodesChange = "T-Chek Express Codes Add/Edit",
  TChekHistoricalChange = "T-Chek Historical Add/Edit",
  DashboardRead = "Dashboard Read",
  DashboardChange = "Dashboard Add/Edit",
  BillingQueueRead = "Billing Queue Read",
  ScansRead = "Scans Read",
  BillingQueueChange = "Billing Queue Add/Edit",
  BillingReviewRead = "Billing Review Read",
  BillingReviewChange = "Billing Review Add/Edit",
  CancelledTripsChange = "Cancelled Trips Edit",
  ReadyForBillRead = "Ready For Bill Read",
  BilledRead = "Billed Read",
  BilledChange = "Billed Add/Edit (Export and Print)",
  BilledChargesEdit = "Billed Charges Edit",
  ChargeTypesRead = "Charge Types Read",
  ChargeTypesChange = "Charge Types Add/Edit",
  CancelledRead = "Cancelled Read",
  DriversRead = "Drivers Read",
  DriversChange = "Drivers Add/Edit/Delete",
  DriversProfileRead = "Drivers Profile Tab Read",
  DriversProfileChange = "Drivers Profile Tab Add/Edit",
  DriversComplianceRead = "Drivers Compliance Tab Read",
  DriversComplianceChange = "Drivers Compliance Tab Add/Edit",
  DriversAssignmentsRead = "Drivers Assignments Tab Read",
  DriversAssignmentsChange = "Drivers Assignments Tab Add/Edit",
  DriversNotesRead = "Drivers Notes Tab Read",
  DriversNotesChange = "Drivers Notes Tab Add/Edit",
  DriversDocumentsRead = "Drivers Documents Tab Read",
  DriversDocumentsChange = "Drivers Documents Tab Add/Edit",
  DriversSettlementsRead = "Drivers Settlements Tab Read",
  DriversSettlementsChange = "Drivers Settlements Tab Add/Edit",
  DriversTeamsRead = "Drivers Teams Tab Read",
  DriversTeamsChange = "Drivers Teams Tab Add/Edit",
  DriversScheduleRead = "Drivers Schedule Tab Read",
  DriversScheduleChange = "Drivers Schedule Tab Add/Edit",
  TractorsRead = "Tractors Read",
  TractorsChange = "Tractors Add/Edit/Delete",
  TrailersRead = "Trailers Read",
  TrailersChange = "Trailers Add/Edit/Delete",
  FuelExportsRead = "Fuel Exports Read",
  InvoiceExportsRead = "Invoice Exports Read",
  BatchExportsRead = "Batch Exports Read",
  VariousReportsRead = "Various Reports Read",
  SettlementsRead = "Settlements Read",
  SettlementsChange = "Settlements Add/Edit",
  PCMilerChange = "PC Miler Add/Edit",
  UsersChange = "Users Add/Edit",
  RolesChange = "Roles Add/Edit",
  BatchChange = "Batch Add/Edit",
  ViewsChange = "Views Add/Edit",
  ConfigChange = "Config Add/Edit",
  TripUpperBoundOverride = "Trip Upper Bound Override",
  OtherTripAssignment = "Other Trip Assignment",
  CustomerReportsRead = "Customer Exports Read",
  CustomerReportsChange = "Customer Exports Add/Edit",
  DispatchDriverAssignmentsRead = "Dispatch Driver Assignments Read",
  DispatchDriverAssignmentsChange = "Dispatch Driver Assignments Add/Edit",
  DispatchFinderRead = "Dispatch Finder Read",
  DispatchFinderChange = "Dispatch Finder Add/Edit",
  DispatchTripRead = "Dispatch Trip Read",
  DispatchTripChange = "Dispatch Trip Add/Edit",
  Admin = "Admin",
}

/** Type-safe lookup for Permissions enum by string key. */
export function getPermission(key: string): Permissions {
  return (Permissions as Record<string, Permissions>)[key];
}
